import styled from 'styled-components';

export const BillingTitle = styled.h2`
  margin-top: 32px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 900;
`;
